<template>
  <div class="parent-wrap">
    <div v-if="childList.length > 0" class="parent-wrap-box">
      <van-nav-bar
        :border="!isHome && isIndex !== 0 && isIndex !== 3"
        :style="{ 'background-color': changeColor.bg, color: changeColor.color }"
      >
        <div slot="left">
          <van-icon
            size="20"
            @click="messageBut"
            :style="{ color: changeColor.color }"
            name="bell"
            dot
            info="99+"
          />
        </div>
        <div slot="title" :style="{ color: changeColor.color }">{{ title }}</div>
        <div slot="right">
          <div v-if="isHome" @click="childShow = true" class="change-child-name nowrap">
            <span class="nowrap" :style="{ color: changeColor.color }">{{
              childData.FullNameStudent
            }}</span>
            <van-icon name="arrow-down" :color="changeColor.color" />
          </div>
          <div v-else class="change-child-name nowrap">
            <span class="nowrap" :style="{ color: changeColor.color }">{{
              childData.FullNameStudent
            }}</span>
          </div>
        </div>
      </van-nav-bar>
      <div class="content-wrap">
        <router-view />
      </div>
      <div class="parent-nav van-hairline--top">
        <div v-for="(item, index) in list" :key="index" class="parent-nav-item">
          <div @click="changeNav(item, index)" class="pr home-bottom-nav">
            <div v-if="isTips && index === 1" class="parent-tips"></div>
            <i class="iconfont" :class="index === isIndex ? 'active' : ''" v-html="item.icon"></i>
            <div class="nav-text" :class="index === isIndex ? 'active' : ''">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <child :childShow="childShow" @listenToChildClose="closeChild"></child>
    </div>
    <div v-else>
      <div class="null-child">
        <img :src="require('@/assets/parent/nullchild.png')" alt />
      </div>
      <div class="text-center null-child-text">暂无关联学生账号，请联系管理员</div>
      <div class="back">
        <div @click="goBack">退出登录</div>
      </div>
    </div>
  </div>
</template>
<script>
import Child from "@/pages/common/views/xy/parent/Child";
export default {
  name: "gatewayFamily",
  components: {
    Child
  },
  data() {
    return {
      childShow: false,
      title: "智慧校园",
      isHome: true,
      changeColor: {
        color: "#fff",
        bg: "#4196ff"
      },
      isIndex: 0,
      list: [
        {
          name: "首页",
          icon: "&#xe611;",
          path: "home"
        },
        {
          name: "私信",
          icon: "&#xe606;",
          path: "letter"
        },
        {
          name: "课程表",
          icon: "&#xe61b;",
          path: "classTable"
        },
        {
          name: "个人中心",
          icon: "&#xe61d;",
          path: "center"
        }
      ],
      websock: null,
      childData: {},
      letterList: [],
      childList: [],
      isTips: false,
      chatIndex: -1
    };
  },
  computed: {
    chat() {
      return this.$store.state.parentInfo.chatIndex;
    },
    child() {
      return this.$store.state.parentInfo.childData;
    }
  },
  watch: {
    child: {
      handler(newVal) {
        this.childData = newVal;
      }
    },
    isHome: {
      handler(newVal) {
        if (newVal) {
          this.changeColor["color"] = "#fff";
          this.changeColor["bg"] = "#4196ff";
        } else {
          this.changeColor["color"] = "#333";
          this.changeColor["bg"] = "transparent";
        }
      },
      deep: true
    },
    chat: {
      handler(newVal) {
        this.chatIndex = newVal;
      },
      deep: true
    },
    letterList: {
      handler(newVal) {
        let newArr = newVal.filter(item => {
          return item.Unread > 0;
        });
        if (newArr.length > 0) {
          this.isTips = true;
        } else {
          this.isTips = false;
        }
        this.$store.commit("parentInfo/addChildList", newVal); //所有孩子信息
      },
      deep: true
    },
    childList: {
      handler(newVal) {
        this.$store.commit("parentInfo/changeChildInfo", newVal); //切换子女信息
      },
      deep: true
    }
  },
  created() {
    this.curUserInfo(); ///获取当前用户信息
    this.$router.push(`/xyParent/home`);
    this.getWebSocketAddress(); //调用websocket
  },
  destroyed() {
    // 页面销毁时关闭长连接
    this.websock.onclose;
  },
  methods: {
    messageBut() {
      this.$router.push("/messageList");
    },
    //====websocket Start====
    async getWebSocketAddress() {
      let res = await this.xyapi.get(
        `${this.xyMApi}/xy/comm/GetWebSocketAddress`,
        null
      );
      if (res.success) {
        this.initWebSocket(res.data); //连接websocket服务
      }
      this.xy.unloading();
    },
    initWebSocket(url) {
      const wsuri = url + "?XYTOKEN=" + this.xy.getCookie(".XYTOKEN");
      this.websock = new WebSocket(wsuri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() {
      console.log("连接成功");
    },
    websocketsend(Data) {
      // 数据发送
      this.websock.send(Data);
    },
    websocketonmessage(val) {
      //接收信息
      let jsonVal = JSON.parse(val.data);
      this.handleMsg(jsonVal);
    },
    websocketonerror() {
      //this.initWebSocket()
    },
    websocketclose() {
      // this.initWebSocket()
      // console.log('断开连接', e)
    },
    handleMsg(jsonVal) {
      //处理websocket信息
      if (this.letterList.length > 0) {
        for (let i = 0, len = this.letterList.length; i < len; i++) {
          if (this.letterList[i].ReceiverID === jsonVal.SenderID) {
            if (this.chatIndex === i) {
              this.letterList[i].Unread = 0;
              let msgArr = this.$store.state.parentInfo.msgList;
              msgArr.push({
                //聊天记录内添加信息
                ReceiverIcon: this.letterList[i].ReceiverIcon,
                ReceiverID: jsonVal.SenderID,
                PrivateLetterBody: jsonVal.MessageInfo
              });
              this.$store.commit("parentInfo/changeMsgList", msgArr);
              //更改为已读
              let sendOption = {
                ReceiverID: jsonVal.SenderID,
                MessageType: 2,
                MessageBody: jsonVal.MessageID
              };
              this.websocketsend(JSON.stringify(sendOption));
            } else {
              this.letterList[i].Unread = this.letterList[i].Unread + 1;
            }
            this.letterList[i].CreateByDate = jsonVal.CreateByDate; //会话列表年月日
            this.letterList[i].CreateByDateName = jsonVal.CreateByDateName; //会话列表时间
            this.letterList[i].PrivateLetterBody = jsonVal.MessageInfo.split("<br/>").join(" "); //会话列表显示最后一条消息
          }
        }
      }
    },
    async getPrivateLetterList() {
      //拉取会话列表
      let res = await this.xyapi.get(
        `${this.xyMApi}/api/InstantMessaging/GetPrivateLetterList`,
        null
      );
      if (res.success) {
        if (res.data.length > 0) {
          let dataList = res.data;
          for (let j = 0, len = this.letterList.length; j < len; j++) {
            for (let i = 0, len = dataList.length; i < len; i++) {
              if (this.letterList[j].ReceiverID === dataList[i].ReceiverID) {
                this.letterList[j].CreateByDate = dataList[i].CreateByDate;
                this.letterList[j].CreateByDateName = dataList[i].CreateByDateName;
                this.letterList[j].PrivateLetterBody = dataList[i].PrivateLetterBody.split(
                  "<br/>"
                ).join(" ");
                this.letterList[j].ReceiverID = dataList[i].ReceiverID;
                this.letterList[j].ReceiverName = dataList[i].ReceiverName;
                this.letterList[j].Unread = dataList[i].Unread;
              }
            }
          }
        }
      }
      this.xy.unloading();
    },
    //====websocket End====
    changeNav(val, i) {
      this.isIndex = i;
      if (i === 0) {
        this.title = "智慧校园";
        this.isHome = true;
      } else {
        this.title = val.name;
        this.isHome = false;
      }
      this.$router.push(`/xyParent/${val.path}`);
    },
    async curUserInfo() {
      //获取当前用户信息
      this.xy.loading();
      let res = await this.xyapi.get(`${this.xyMApi}/api/Users/CurUserInfo`, null);
      if (res.success) {
        this.$store.commit("parentInfo/addUserInfo", res.data);
        this.curStudentInfo(res.data.UserID);
      } else {
        this.xy.unloading();
      }
    },
    async curStudentInfo(id) {
      //获取当前用户的孩子
      this.letterList = [];
      let res = await this.xyapi.get(
        `${this.xyMApi}/api/Users/GetChildrenByParentID?ParentID=${id}`,
        null
      );
      if (res.success) {
        this.childList = res.data;
        //if (this.$store.state.parentInfo.childData.length < 1) {   }
        //首次登录获取到第一个孩子信息
        this.$store.commit("parentInfo/addChildData", res.data[0]);

        this.childData = this.$store.state.parentInfo.childData; //当前孩子信息
        if (res.data.length > 0) {
          for (let i = 0, len = res.data.length; i < len; i++) {
            this.letterList.push({
              CreateByDate: "",
              CreateByDateName: "",
              PrivateLetterBody: "",
              ReceiverID: res.data[i].ChildrenID,
              ReceiverIcon: res.data[i].Icon,
              ReceiverName: res.data[i].FullNameStudent,
              Unread: 0
            });
          }
        }
        this.getPrivateLetterList(); //拉取会话列表
      }
    },
    closeChild(val) {
      // 监听子组件关闭事件
      this.childShow = val;
    },
    goBack() {
      this.$dialog
        .confirm({
          title: "退出",
          message: "您确定要退出登录吗？"
        })
        .then(() => {
          localStorage.clear();
          this.xy.removeCookie(".XYTOKEN");
          this.$router.push("/");
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less" scoped>
.parent-wrap {
  height: 100%;
  display: flex;
  flex-flow: column;
  .parent-wrap-box {
    height: 100%;
    display: flex;
    flex-flow: column;
    .change-child-name {
      display: flex;
      align-items: center;
      span {
        width: 120px;
        text-align: right;
      }
    }
  }
  .content-wrap {
    flex: 1;
    overflow-y: auto;
  }
  .parent-nav {
    width: 100%;
    height: 90px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
    font-size: 22px;
    div {
      flex: 1;
      img {
        width: 34px;
        margin-bottom: 10px;
      }
    }
    .parent-tips {
      position: absolute;
      top: 0;
      right: 70px;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background-color: #ef4f4f;
    }
    .home-bottom-nav {
      color: #ccc;
      i.active {
        color: #2e7bfd;
      }
      .nav-text {
        margin-top: 10px;
      }
      .nav-text.active {
        color: #2e7bfd;
      }
    }
  }
  .null-child {
    width: 90%;
    margin: 100px auto;
    img {
      width: 100%;
    }
  }
  .null-child-text {
    color: #666;
    font-size: 28px;
  }
  .back {
    text-align: center;
    margin-top: 100px;
    font-size: 32px;
    color: #4196ff;
  }
}
</style>
